import { styled } from "styled-components";

import { useEffect, useState } from "react";

const options = {
  timeZone: "America/Phoenix",
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
};

export default function Footer() {
  const [time, setTime] = useState("");

  useEffect(() => {
    function getTime() {
      const timenow = new Intl.DateTimeFormat("en-US", options)
        .format(new Date())
        .replace(" at ", ", ");
      setTime(timenow);
    }
    const interval = setInterval(getTime, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Container className="wrap">
      <span>Built with coffee & code </span>
      <span>&#169; Sivasanker</span>
      <div className="location">
        <div>
          <span />
          <span>Phoenix, AZ</span>
        </div>
        <span>{time}</span>
      </div>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  border-top: 1px solid #2d2d2dff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #abababff;
  user-select: none;

  .location {
    div {
      display: flex;
      gap: 8px;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 2px;
    }
    span:first-child {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: rgb(29, 244, 129);
      display: inline-block;
      flex-shrink: 0;
    }

    span {
      font-size: 14px;
      color: #abababff;
      font-weight: 300;
    }
  }

  @media (max-width: 768px) {
    font-size: 10px !important;

    .location {
      span {
        font-size: 10px;
        text-align: right;
      }
    }
  }
`;
